import React from "react";

import Questify from "../assets/Questify.png";
import SizzleSpot from "../assets/SizzleSpot.png";
import SkillSwap from "../assets/project1.png";
import Stocksense from "../assets/project2.png";

const Portfolio = () => {
  const portfolios = [
    {
      id: 1,
      src: SkillSwap,
      demo: "https://youtu.be/v8pQ7GXCqy8",
      code: "https://github.com/snehatomar1205/SkillSwap",
    },
    {
      id: 2,
      src: Stocksense,
      demo: "https://youtu.be/yqV14k5c_Ig",
      code: "https://github.com/snehatomar1205/StockSense",
    },
    {
      id: 3,
      src: Questify,
      demo: "https://youtu.be/zRwkf2Hp0_M",
      code: "https://github.com/snehatomar1205/Questify",
    },
    {
      id: 4,
      src: SizzleSpot,
      demo: "https://youtu.be/PKT7vjvAh1Q",
      code: "https://github.com/snehatomar1205/Sizzle-Spot---recipe",
    },
  ];

  return (
    <div
      name="portfolio"
      className="bg-gradient-to-b from-gray-800 via-black to-gray-800 w-full text-white min-h-screen pt-20"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Portfolio
          </p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {portfolios.map(({ id, src, demo, code }) => (
            <div key={id} className="shadow-md shadow-gray-600 rounded-lg">
              <img
                src={src}
                alt="project preview"
                className="rounded-md duration-200 hover:scale-105"
              />

              <div className="flex items-center justify-center">
                <a
                  href={demo}
                  target="_blank"
                  rel="noreferrer"
                  className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105 text-center"
                >
                  Demo
                </a>

                <a
                  href={code}
                  target="_blank"
                  rel="noreferrer"
                  className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105 text-center"
                >
                  Code
                </a>
              </div>
            </div>
          ))}
          <br />
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
